<script>
import Vue from 'vue';
import LoaderMixin from '../mixins/loader_mixin';

export default Vue.component('loader', {

    mixins: [
        LoaderMixin,
    ],
    props: {
        minHeight: {
            type: [String, Boolean],
            default: '200px',
        },

        position: {
            type: String,
            default: 'absolute',
        },

        transparent: {
            type: Boolean,
            default: false,
        },

    },

    computed: {
        overlayStyle() {
            return {
                'min-height': this.minHeight,
                position: this.position,
                background: this.transparent ? 'transparent' : false,
            };
        },
    },
});
</script>
<template>
    <div v-if="isLoading" class="spinner-overlay fade in" :style="overlayStyle">
        <div class="spinner-small" />
    </div>
</template>
